import { Link } from "react-router-dom";
import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import PageHeader from "@/components/feature/PageHeader";
import StartProjectCTA from "@/components/feature/StartProjectCTA";
import { BleedSection, BleedSectionMobile } from "@/components/feature/BleedSection";
import { services } from "@/mocks/services";
import { projects } from "@/mocks/projects";

const SERVICES_IMG = "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_home-services-support.webp";

export default function ServicesIndex() {
  const list = (
    <>
      <h2 className="font-serif-display leading-[1.08] mb-8"
          style={{ fontSize: "clamp(26px,2.2vw,36px)", letterSpacing: "-0.018em" }}>
        Four core capabilities, one integrated team.
      </h2>
      <ul>
        <li className="border-t hairline" />
        {services.map(s => (
          <li key={s.slug} className="border-b hairline">
            <Link to={`/services/${s.slug}`}
                  className="group grid grid-cols-12 items-center gap-4 py-5 cursor-pointer">
              <span className="col-span-2 eyebrow text-ink-soft">{s.num}</span>
              <span className="col-span-8 font-serif-display font-light group-hover:text-accent transition-colors"
                    style={{ fontSize: "clamp(18px,1.7vw,26px)", letterSpacing: "-0.014em" }}>
                {s.title}
              </span>
              <span className="col-span-2 flex justify-end">
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center text-ink-soft group-hover:text-accent transition-all group-hover:translate-x-1"
                   style={{ fontSize: "18px" }} />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );

  return (
    <div className="min-h-screen bg-warm-bg text-ink">
      <SiteNav />
      <PageHeader
        eyebrow="Capabilities"
        title={<>What we do.</>}
        intro="Four core service categories, delivered as a single integrated design and construction effort."
        crumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
      />

      <BleedSection eyebrow="What We Do" imgSrc={SERVICES_IMG}
        imgAlt="Warm residential interior detail" imgSide="right" bg="#FFFFFF">
        {list}
      </BleedSection>
      <BleedSectionMobile eyebrow="What We Do" imgSrc={SERVICES_IMG}
        imgAlt="Warm residential interior detail" bg="#FFFFFF">
        {list}
      </BleedSectionMobile>

      <section className="w-full py-24 md:py-32">
        <div className="w-full mb-10" style={{ paddingLeft: "clamp(20px, 5vw, 96px)", paddingRight: "clamp(20px, 5vw, 96px)" }}>
          <div className="flex items-end justify-between">
            <span className="eyebrow">Related Work</span>
            <Link to="/projects" className="arrow-link text-[12px] tracking-[0.12em] uppercase cursor-pointer">
              All Projects
              <i className="ri-arrow-right-line arrow w-4 h-4 flex items-center justify-center" />
            </Link>
          </div>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-0">
          {projects.slice(0, 3).map(p => (
            <Link key={p.slug} to={`/projects/${p.slug}`}
                  className="group cursor-pointer block [&_.meta]:px-[clamp(20px,5vw,96px)]">
              <div className="overflow-hidden">
                <img src={p.image} alt={p.title}
                     className="w-full block transition-transform duration-700 group-hover:scale-[1.02]"
                     style={{ aspectRatio: "4/3", objectFit: "cover" }} />
              </div>
              <div className="meta mt-4 mb-16 text-center">
                <span className="eyebrow">{p.category}</span>
                <div className="mt-2 font-serif-display font-light" style={{ fontSize: "22px" }}>{p.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <StartProjectCTA />
      <SiteFooter />
    </div>
  );
}